var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHcpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 55,
    viewBox: "0 0 49 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.08694 40.3077L5.07155 21.2385C5.64078 19.2462 7.63309 17.5385 9.91002 17.5385H15.3177V14.1231C15.3177 11.2769 17.5946 9 20.4408 9H27.2716C30.1177 9 32.3946 11.2769 32.3946 14.1231V17.5385H37.8023C40.0792 17.5385 42.0716 19.2462 42.6408 21.2385L46.6254 40.3077C47.1946 43.1538 44.9177 46 41.7869 46H6.21001C2.79463 46 0.517708 43.1538 1.08694 40.3077ZM29.5485 14.1231C29.5485 12.9846 28.41 11.8462 27.2716 11.8462H20.4408C19.3023 11.8462 18.1639 12.9846 18.1639 14.1231V17.5385H29.5485V14.1231ZM15.3177 34.6154H21.01V40.3077H26.7023V34.6154H32.3946V28.9231H26.7023V23.2308H21.01V28.9231H15.3177V34.6154Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHcpIcon);
export default __webpack_public_path__ + "static/media/hcp-icon.fea4e827fa565eb7490e6f7c0aa8eb3c.svg";
export { ForwardRef as ReactComponent };